import api from './interceptor';

const BASE_URL_V3 = 'api/v3/medical-test';

export default {
  // API Version 2

  addAnalyze: params => api.post(`${BASE_URL_V3}`, params),
  updateAnalyze: (id, params) => api.put(`${BASE_URL_V3}/${id}`, params),
  getAnalyzes: params => api.get(`${BASE_URL_V3}`, { params }),
  deleteAnalyze: id => api.delete(`${BASE_URL_V3}/${id}`),
};
